import * as _ from 'lodash';

import { getApiConfig } from './../../../utilities/index';
import {loadingDialog_show, messageBox_Show} from './../../../actions/A_Popups';
import {POPUP_FILTER_ASSIGN_TO_FEATURES} from "../../../constants/actionTypes";
import {hashHistory} from 'react-router';

export const ActionTypes = {
  GET_FEATURES_GROUP_HEADERS_LOADING: 'get-features-group-headers-loading',
  GET_FEATURES_GROUP_HEADERS_LOADED: 'get-features-group-headers-loaded',
  GET_FEATURES_FROM_GROUP_LOADING: 'get-features-from-group-loading',
  GET_FEATURES_FROM_GROUP_LOADED: 'get-features-from-group-loaded',
  MARK_FEATURE_CHECKED: 'mark-feature-checked',
  MARK_ALL_FEATURES_CHECKED: 'mark-all-features-checked',
  RESET_TERM: 'reset-search-term',
  COLLAPSE_FEATURES_FILTERS: 'collapse-feature-filters',
  MARK_FEATURE_FILTER_FOR_DELETION: 'mark-feature-filter-for-deletion',
  CANCEL_FEATURE_FILTER_DELETION: 'cancel-feature-feature-deletion',
  DELETE_FEATURES_FILTERS: 'delete-features-filters',
  FILTER_GROUPS_NAMES: 'filter-groups-names',
  SELECT_FEATURES_GROUP: 'select-features-group',
  FETCH_FEATURES_FROM_CURRENT_STATE_START: 'fetch-features-from-current-state-start',
  FETCH_FEATURES_FROM_CURRENT_STATE_END: 'fetch-features-from-current-state-end',
  SET_PAGE: 'set-page',
  SET_TERM: 'set-term',
  SET_ITEMS_PER_PAGE: 'set-items-per-page',
  HANDLE_COLOR_FILTER_CLICK: 'handle-color-filter-click',
  HANDLE_NON_COLOR_FILTER_CLICK: 'handle-non-color-filter-click'
}

export const handleColorFilterClick = (item ,type) => ({type: ActionTypes.HANDLE_COLOR_FILTER_CLICK, payload: {item, type}});

export const handleNonColorFilterClick = (item ,type) => ({type: ActionTypes.HANDLE_NON_COLOR_FILTER_CLICK, payload: {item, type}});

export const setItemsPerPage = itemsPerPage => ({type: ActionTypes.SET_ITEMS_PER_PAGE, payload: {itemsPerPage}});

export const setTerm = term => ({type: ActionTypes.SET_TERM, payload: {term}});

export const setPage = page => ({type: ActionTypes.SET_PAGE, payload: {page}});

export const setGroupsTerm = groupsTerm => ({type: ActionTypes.FILTER_GROUPS_NAMES, payload: {groupsTerm}});

export const deleteFeaturesFilters = () => {
  return (dispatch, getState) => {
    dispatch(messageBox_Show(true, 'error', 'Delete?', 'Are you sure? This cannot be undone!!!',
      [
        {
          'text': 'Delete',
          'onClick': () => {
            dispatch(messageBox_Show(false));
            const {filtersAssignToFeatures} = getState();
            const {selectedGroupHeader, page, term} = filtersAssignToFeatures;
            const data = {records: _.values(filtersAssignToFeatures.featuresFiltersToBeDeleted.toJS())};
            dispatch(loadingDialog_show(true, 'Deleting...', 'Deleting selected filters...'));
            getApiConfig('Filters/DeleteFeaturesFilters')
              .post(data)
              .then(result => {
                dispatch(loadingDialog_show(false));
                dispatch(cancelFeatureFilterDeletion()); // clear IDs from redux store
                dispatch(fetchFeaturesFromCurrentState()); // reload features
              })
          }
        },
        {
          'text': 'Cancel',
          'onClick': () => {
            dispatch(messageBox_Show(false));
          }
        }
      ]))
  }
}

export const cancelFeatureFilterDeletion = () => ({type: ActionTypes.CANCEL_FEATURE_FILTER_DELETION});

export const markFeatureFilterForDeletion = (featureId, filterValueId, mark) =>
  ({type: ActionTypes.MARK_FEATURE_FILTER_FOR_DELETION, payload:{featureId, filterValueId, mark}});

export const collapseFeaturesFilters = collapse => ({type: ActionTypes.COLLAPSE_FEATURES_FILTERS, payload: {collapse}});

export const getFeaturesGroupHeaders = () => {
  return (dispatch, getState) => {
    dispatch({type: ActionTypes.GET_FEATURES_GROUP_HEADERS_LOADING});

    const groupHeadersPromise = getApiConfig('Filters/GetFeaturesGroupHeaders').get();
    const colorFiltersPromise = getApiConfig('Filters/GetFeaturesFilterGroups').get();

    return Promise.all([groupHeadersPromise, colorFiltersPromise])
      .then(([headers, filters]) => {
        dispatch({
          type: ActionTypes.GET_FEATURES_GROUP_HEADERS_LOADED,
          payload: {
            headers,
            filters
          }
        });
        fetchFeaturesFromCurrentState()(dispatch, getState);
      })
  }
}

export const fetchFeaturesFromCurrentState = () => {
  return (dispatch, getState) => {
    const {filtersAssignToFeatures} = getState();
    const {selectedFeaturesGroups, page, term, itemsPerPage, currentFilterValues} = filtersAssignToFeatures;
    dispatch(loadingDialog_show(true, 'Loading...', 'Loading features...'));
    dispatch({type: ActionTypes.FETCH_FEATURES_FROM_CURRENT_STATE_START});
    return getApiConfig(`Filters/GetFeaturesFromGroup`)
      .post({
        params: {
          groupsIds: _.keys(selectedFeaturesGroups).join(',')
        },
        page,
        pageSize: itemsPerPage !== 'All' ? parseInt(itemsPerPage) : -1,
        filterBy: {
          term,
          filtersValuesIds: currentFilterValues.join(',')
        }
      })
      .then(result => {
        dispatch({type: ActionTypes.GET_FEATURES_FROM_GROUP_LOADED, payload: result});
        dispatch({type: ActionTypes.FETCH_FEATURES_FROM_CURRENT_STATE_END, payload: result});

        dispatch(loadingDialog_show(false));
      });
  }
}

export const selectFeaturesGroup = (group, select) =>
  ({type: ActionTypes.SELECT_FEATURES_GROUP, payload: {group, select}});

export const getFeaturesFromGroup = (group, term, page) => {
  return dispatch => {
    dispatch({type: ActionTypes.GET_FEATURES_FROM_GROUP_LOADING, payload: group});
    dispatch(loadingDialog_show(true, 'Loading...', 'Loading features from group ' + group.name));

    return getApiConfig(`Filters/GetFeaturesFromGroup`)
      .post({
        params: {
          groupId: group.id
        },
        page,
        filterBy: {term}
      })
      .then(result => {
        dispatch({
          type: ActionTypes.GET_FEATURES_FROM_GROUP_LOADED,
          payload: result});

        dispatch(loadingDialog_show(false));
      });
  }
}


export const markFeatureChecked = (feature, check) => {
  return {
    type: ActionTypes.MARK_FEATURE_CHECKED,
    payload: {feature, check}
  }
}

export const markAllFeaturesChecked = (check) => {
  return {
    type: ActionTypes.MARK_ALL_FEATURES_CHECKED,
    payload: check
  }
}

export const showAssignPopup = show => {
  return {
    type: POPUP_FILTER_ASSIGN_TO_FEATURES,
    payload: {show}
  }
}

export const backToFiltersManagement = () => {
  return (dispatch) => {
    dispatch({type: ActionTypes.RESET_TERM});
    hashHistory.push('/filters');
  }
}
